import React, { useRef, useState } from 'react';
import { Autocomplete, TextField, Typography } from '@mui/material';
import './style.css'
import SoftTypography from 'components/SoftTypography';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
const CommonAutocomplete = ({
  options = [],
  label = 'Select',
  onBlur,
  value,
  onChange,
  getOptionLabel,
  isClearable = true,
  placeholder,
  disabled = false,
  sx = {},
  invalid,
  setLoading,
  loading = false,
  onInputChange,
  // inputValue: externalInputValue,
  // setInputValue: externalSetInputValue,
  ...rest
}) => {

  const userTheme = useSelector((state) => state.commonSlice.theme);
  const debounceRef = useRef(null);
  // If parent does not pass inputValue & setInputValue, manage internally
  const [internalInputValue, setInternalInputValue] = useState('');
  const inputValue = internalInputValue;
  const setInputValue = setInternalInputValue;

  const handleInputChange = (event, newValue, reason) => {
    if (reason === 'clear') {
      setInputValue('');
      onInputChange?.('');
      return;
    }

    if (reason === 'input') {
      clearTimeout(debounceRef.current);
      setInputValue(newValue);
      debounceRef.current = setTimeout(() => {
        onInputChange?.(newValue);
      }, 500);
    }
  };
  useEffect(() => {
    if (!rest?.multiple && value?.label) {
      setInternalInputValue(value.label);
    }
  }, [value, rest?.multiple]);
  return (
    <Autocomplete
      disablePortal
      options={options || []}
      className='add-custom'
      loading={loading}
      noOptionsText={
        <SoftTypography variant="caption" sx={{ p: 0, color: '#000' }}>
          No data found
        </SoftTypography>
      }
      inputValue={inputValue}
      value={value}
      onChange={(event, newValue) => {
        setInputValue(newValue?.label || '');
        onChange?.(name, newValue);
        onInputChange?.('');
      }}
      onInputChange={handleInputChange}
      invalid={invalid}
      onBlur={onBlur}
      isClearable={isClearable}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      getOptionLabel={(option) => option?.label || 'No Data Found'}
      sx={{
        '& .MuiAutocomplete-tag': {
          backgroundColor: '#333 !important',
          color: ' #fff!important',
        },
        '& .MuiAutocomplete-popupIndicator': {
          color: '#000 !important',
        },
        '& .MuiAutocomplete-clearIndicator': {
          color: '#000 !important',
        },
      }}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder || 'Select...'}
          InputLabelProps={{ shrink: false }}
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: userTheme == 'dark' ? '#404040 !important' : '#fff !important',
              color: '#495057 !important',
              border: invalid ? '.4px solid #fd5c70' : '.4px solid #456',
              '& input': {
                color: '#495057 !important',
                backgroundColor: '#404040',
              },
              '& .MuiAutocomplete-endAdornment button': {
                color: '#fff !important', // popup + clear icons
              },
            },
            '& label': {
              color: '#495057 !important',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#404040',
            },
          }}
        />
      )}
      renderOption={(props, option) => (
        <li {...props} style={{ backgroundColor: '#2b2b2b', color: '#495057', marginTop: '5px', background: 'transparent' }}

          sx={{
            '& .MuiAutocomplete-paper': {
              backgroundColor: '#1e1e1e !important',
            },
            '& .MuiAutocomplete-option': {
              backgroundColor: '#2b2b2b !important',
              color: '#e0e0e0 !important',
              '&:hover': {
                backgroundColor: '#3c3c3c !important',
              },
              '&[aria-selected="true"]': {
                backgroundColor: '#555555 !important',
              },
            },
          }}
        >
          {option.label}
        </li>
      )}
      {...rest}
    />

  );
};

export default CommonAutocomplete;
